import React from 'react'
import classes from "./style.module.scss";

const Button = ({ text, onClick, className, secondary = false, disabled = false, smallBtn = false, style, StartIcon }) => {
  return (
    <>
      <button
        onClick={onClick}
        style={style}
        disabled={disabled}
        className={`${classes.buttonWrapper} ${classes?.primaryBtn} ${
          smallBtn ? classes.smallBtn : ""
        }  ${secondary ? classes.secondary : ""} ${
          disabled ? classes.disabled : ""
        } ${StartIcon ? "flex items-center" : ""} ${className}`}
      >
        {StartIcon && (
          <img src={StartIcon} className={classes.buttonIcon} alt="Icons" />
        )}
        {text}
      </button>
    </>
  );
}

export default Button